import { mixpanelTrack } from "./mixpanelTrack";

export type SubscriptionSubsection =
  | "Hero"
  | "SBC"
  | "Squad Builder"
  | "My Evolutions"
  | "Bottom";

const SECTION = "Subscription";

export const trackUpgrade = (subsection: SubscriptionSubsection) =>
  mixpanelTrack("upgrade", {
    section: SECTION,
    subsection,
    context: "cta",
    action_type: "lifecycle",
  });
